<template>
  <div class="container text-center">
    <titular />
    <div class="row mb-5">
      <div class="col-12 col-sm-6 col-md-3 mx-auto">
        <div class="input-group mb-2 mr-sm-2">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fas fa-user" title="Treballador" v-tooltip></i></div>
          </div>
          <select class="custom-select" v-model="trabajadorEscogido">
            <option value="" hidden>Treballador</option>
            <option v-for="(trabajador, index) in trabajadores" :key="index" :value="trabajador.id">{{ trabajador.nombre_completo }}</option>
          </select>
        </div>
      </div>
    </div>
    <estadistica v-if="trabajadorEscogido" :trabajador="trabajadorEscogido" :rango_inicio="rango_inicio" :rango_fin="rango_fin" :esFiltrado="filtrado" />
    <vacio>Selecciona treballador per veure les dades.</vacio>
  </div>
</template>

<script>
import Estadistica from "../components/EstadisticaTrabajador.vue";
export default {
  components: { Estadistica },
  name: "KPITreballador",
  data() {
    return {
      loading: {
        filtrado: false,
      },
      trabajadores: [],
      trabajadorEscogido: "",
      rango_inicio: "",
      rango_fin: "",
      filtrado: 0,
    };
  },
  computed: {
    rango_max: function () {
      let date = new Date();

      date.setDate(date.getDate());

      return this.toDateISOString(date);
    },
  },
  mounted() {
    this.$http.get("api/treballadors?activos&order=nom").then((response) => (this.trabajadores = response.data));
  },
  methods: {
    reiniciar() {
      this.rango_inicio = "";
      this.rango_fin = "";

      this.filtrar();
    },
    toDateISOString: function (date) {
      return date.toISOString().split("T")[0];
    },
    filtrar: function () {
      this.filtrado++;
    },
  },
};
</script>